import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import MiniPDPCJAMiddleware from 'yoda-mini-pdp/lib/middlewares/CJAMiddleware';
import CouponMiddleware from './CouponMiddleware';
import CJAMiddleware from './CJAMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    CouponMiddleware,
    CJAMiddleware,
    MiniPDPCJAMiddleware,
    MiniPDPAnalyticsMiddleware,
];

export default rootMiddleware;
